<template lang="pug">
  server-data(
    :method="(params) => $api.enrollments.getEnrollmentList(this.courseId, params)"
    search-field-name="search[name]"
    @init="resetQuery"
    v-slot="{ selectProps, search, loadMoreItems, loading }"
  )
    v-autocomplete-more(
      v-model="inputValue"
      v-bind="{ ...selectProps, ...$attrs }"
      :search-input.sync="searchInput"
      label="Выберите набор"
      filled
      cache-items
      item-text="code"
      item-value="id"
      @update:search-input="search"
      @load-more-items="loadMoreItems"
    )

</template>
<script>

export default {
  props: {
    courseId: {
      type: Number,
      required: true,
    },
    value: {
      type: [Array, Object, Number],
      default: null,
    },
  },
  data() {
    return {
      searchInput: null,
      menu: false,
      // inputValue: this.value.map(({ id }) => id),
    };
  },
  computed: {
    inputValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  // mounted() {
  //   this.query = {};
  // },
  methods: {

    resetQuery() {
      this.query = {};
    },
  },
};
</script>
